var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRename(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.56 11.462l-9.493 9.493-2.78.435.338-2.942 9.46-9.46 2.474 2.474zm1.414-1.414l1.06-1.06a1.75 1.75 0 00-2.475-2.475l-1.06 1.06 2.475 2.475zm2.474.354L10.02 22.83 4 23.773l.717-6.247L17.145 5.098a3.75 3.75 0 015.303 5.304z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOC41NTk0IDExLjQ2MjRMOS4wNjcgMjAuOTU0OEw2LjI4NjY2IDIxLjM5MDRMNi42MjQ1IDE4LjQ0NzVMMTYuMDg0NSA4Ljk4NzUyTDE4LjU1OTQgMTEuNDYyNFpNMTkuOTczNiAxMC4wNDgyTDIxLjAzNDMgOC45ODc1QzIxLjcxNzcgOC4zMDQwOCAyMS43MTc3IDcuMTk2MDQgMjEuMDM0MyA2LjUxMjYyQzIwLjM1MDkgNS44MjkyMSAxOS4yNDI4IDUuODI5MjEgMTguNTU5NCA2LjUxMjYyTDE3LjQ5ODcgNy41NzMzMUwxOS45NzM2IDEwLjA0ODJaTTIyLjQ0ODUgMTAuNDAxN0wxMC4wMjA0IDIyLjgyOThMNCAyMy43NzNMNC43MTcxIDE3LjUyNjVMMTcuMTQ1MiA1LjA5ODQxQzE4LjYwOTcgMy42MzM5NCAyMC45ODQgMy42MzM5NSAyMi40NDg1IDUuMDk4NDFDMjMuOTEzIDYuNTYyODggMjMuOTEzIDguOTM3MjUgMjIuNDQ4NSAxMC40MDE3WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgRename as ReactComponent };